import { render, staticRenderFns } from "./weatherFarmCockpitPage.vue?vue&type=template&id=672e91e1&"
import script from "./weatherFarmCockpitPage.vue?vue&type=script&lang=js&"
export * from "./weatherFarmCockpitPage.vue?vue&type=script&lang=js&"
import style0 from "./weatherFarmCockpitPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports